import { create } from "zustand";

type StaffMemberFormValues = {
  firstName?: string;
  lastName?: string;
  title?: string;
  department?: string;
  email?: string;
  phone?: string;
  officeHours?: string;
  officeLocation?: string;
  bio?: string;
  sortOrder?: number;
  isActive?: boolean;
  photoMediaId?: string;
};

type State = {
  isOpen: boolean;
  staffMemberId: string | null;
  defaultValues: StaffMemberFormValues;
};

type Actions = {
  setIsModalOpen: (isOpen: boolean) => void;
  setStaffMemberId: (id: string | null) => void;
  setDefaultValues: (values: StaffMemberFormValues) => void;
};

export const useStaffDirectoryModal = create<State & Actions>((set) => ({
  isOpen: false,
  staffMemberId: null,
  defaultValues: {},
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setStaffMemberId: (id) => set({ staffMemberId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
}));
